<template>
    <div class="schoolList">
        <div class="search_container searchArea">
            <el-form :inline="true" :model='searchForm' ref="searchForm" class="demo-form-inline search-form">
                <el-form-item label="查找">
                    <el-input v-model="searchForm.searchText" placeholder="单位名称"  @keyup.enter.native='loadSchoolList'></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" size ="mini" icon="search" @click='loadSchoolList'>查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size ="mini" icon="search" @click='openSchool(null)'>添加</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table_container">
            <el-table v-loading="loading" :data="tableData" style="width: 100%" align='center'>

                <el-table-column prop="name" label="单位名称"  width="150" align='center' ></el-table-column>
                <el-table-column prop="area" label="校区" width="200" align='center' ></el-table-column>
                <el-table-column prop="address" label="地址" align='center' ></el-table-column>
                <el-table-column prop="admin_count" label="管理员数" align='center' :formatter="formatterAdminCount"></el-table-column>
                <el-table-column prop="operation" align='center' label="操作" width="300">
                    <template slot-scope='scope'>
                        <el-button icon='edit' size="mini" @click='openSchool(scope.row)'>编辑</el-button>
                        <el-button type="danger" icon='edit' size="mini" @click='onDeleteSchool(scope.row)'>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination  :pageSize="searchForm.pageSize" :currentPage="searchForm.pageNo" :pageTotal="searchForm.totalCount" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
        </div>
        <schoolDialog ref="schoolDialog" :school="selSchool" @ok="loadSchoolList"></schoolDialog>
    </div>
</template>

<script>
    import * as mUtils from '@/utils/mUtils'
    import {mapState, mapActions} from 'vuex'
    import XEUtils from 'xe-utils'
    import schoolDialog from "./schoolDialog";
    import * as simpleApi from "request/simple";
    import Pagination from "@/components/pagination";

    export default {
        name: 'schoolList',
        data(){
            return {
                tableData: [], tableHeight:0,
                loading:true, isShow:false,
                selSchool: null, selSchoolDtl: null,
                searchForm:{ pageNo: 1, pageSize: 50, totalCount: 0, searchText: null},
            }
        },
        components:{
            schoolDialog, Pagination
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            })
        },
      	mounted() {
            this.loadSchoolList();
	   },
        methods: {

            loadSchoolList(){
                this.loading = true;

                let search = { searchText: mUtils.searchText(this.searchForm.searchText), licenceId: this.userInfo.licenceId, orderBy: 'name'};
                let param = { controllerName: 'school', methodName: '/list', pageNo: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        this.tableData = data.result;
                        this.searchForm.pageNo = data.pageNo;
                        this.searchForm.pageSize = data.pageSize;
                        this.searchForm.totalCount = data.totalCount;
                    }
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    console.log("error")
                });
            },

            formatterStatus(item) {

                if(item.status == '00'){
                    return '正常';
                }else if(item.status == '01'){
                    return '禁用';
                }
                return '';

            },
            formatterAdminCount(row, column, cellValue, index){
                if(cellValue != null && cellValue > 0){
                    return cellValue;
                }
                return '未设置';
            },
            // 上下分页
            handleCurrentChange(val){
                this.searchForm.pageNo = val;
                this.loadSchoolList()
            },
            // 每页显示多少条
            handleSizeChange(val){
                this.searchForm.pageSize = val;
                this.loadSchoolList()
            },
            onDeleteSchool(row){
                let id = row.id
                let that = this;
                this.$confirm('此操作将永久删除该任务以及明细, 是否继续?', '提示', {
                    confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                }).then(() => {

                    let param = { controllerName: 'school', methodName: '/delete', param: { id: id }};
                    simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                        if (code == 0) {
                            that.$message({ type: 'success', message: '删除成功!'});
                            that.loadSchoolList()
                        }
                        if (code == -3) {
                            that.$message({ type: 'error', message: '该单位下已有数据，请先清除数据后再删除！'});
                            return ;
                        }
                    });
                }).catch(() => {

                });
            },

            openSchool(row){
                if(row != null){
                    this.selSchool = row;
                }else{
                    this.selSchool = { id: null, licenceId: null,  name: null, area: null, address: null, time: (new Date()).getMilliseconds()};
                }
                this.$refs.schoolDialog.showDialog();
            },


        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

    .search_container{

    }
    .btnRight{
        float: right;
        margin-right: 0px !important;
    }
    .searchArea{
        background:rgba(255,255,255,1);
        border-radius:2px;
        padding: 18px 18px 0;
    }
    .table_container{
        padding: 10px;
        background: #fff;
        border-radius: 2px;
    }
    .el-dialog--small{
       width: 600px !important;
    }
    .pagination{
        text-align: left;
        margin-top: 10px;
    }

</style>


